import '../../../dashboard_results/dashboard_query_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.Dashboards.Modes.Publications'

class Monitoring.Views.Dashboards.Modes.Publications.ContentsSectionView extends Monitoring.Views.DashboardQueryView

  template: JST["backbone/templates/monitoring/dashboards/modes/publications/contents_section"]

  initialize: (@options) ->
    @defaultSearchMethod = 'search'
    super(@options)

  reload: ->
    @newSearch()

  searchSelectedPostsComments: (selectedPosts, dateFrom) ->
    @resetSearchQuery()
    @searchQuery.addDateFrom(dateFrom)
    @addSelectedPostsTo(selectedPosts)
    @reload()

  addSelectedPostsTo: (selectedPosts) ->
    selectedPosts.forEach (post) =>
      @searchQuery.addPost(post.parent_search_id, post.provider)

  resetSearchQuery: ->
    charts = @searchQuery.get('charts')
    channels = @searchQuery.get('channels')

    @searchQuery.set(@searchQuery.defaults())

    @searchQuery.set('charts', charts)
    @searchQuery.set('channels', channels)

  _changeSession: (newSession) ->
    # do nothing for publications session. Query and Session only change for the posts section.
